// src/Components/Quran/ByJuz/ByJuz.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, Typography, Grid } from '@mui/material';

const ByJuz = () => {
  const [juzList, setJuzList] = useState([]);

  useEffect(() => {
    const fetchJuzList = async () => {
      try {
        const response = await fetch('https://api.alquran.cloud/v1/quran/uthmani');
        const data = await response.json();

        const juzNames = [
          "Alif-laam-meem (آلم)",
          "Sayaqūlu (سَيَقُولُ)",
          "Tilka ’r-Rusulu (الرُّسُلُ تِلْكَ)",
          "Lan Tana Loo (تَنَالُوا لَنْ)",
          "Wal Mohsanat (وَالْمُحْصَنَاتُ)",
          "Yuhibbullah (اللَّهُ يُحِبُّ لَا)",
          "Wa Iza Samiu (سَمِعُوا وَإِذَا)",
          "Wa Lau Annana (أَنَّنَا وَلَوْ)",
          "Qalal Malao (الْمَلَأُ قَالَ)",
          "Wa A'lamu (وَاعْلَمُوا)",
          "Yatazeroon (يَعْتَذِرُونَ)",
          "Wa Ma Min Da'abat (دَابَّةٍ مِنْ وَمَا)",
          "Wa Ma Ubrioo (بَرِّئُوَمَا)",
          "Rubama (رُبَمَا)",
          "Subhanallazi (الَّذِي سُبْحَانَ)",
          "Qal Alam (أَلَمْ قَالَ)",
          "Aqtarabo (اقْتَرَبَ)",
          "Qadd Aflaha (أَفْلَحَ قَدْ)",
          "Wa Qalallazina (الَّذِينَ وَقَالَ)",
          "A'man Khalaq (خَلَقَ أَمَّنْ)",
          "Utlu Ma Oohi (أُوحِيَ مَا اتْلُ)",
          "Wa Manyaqnut (يَقْنُتْ وَمَنْ)",
          "Wa Mali (لِيَ وَمَا)",
          "Faman Azlam (أَظْلَمُ فَمَنْ)",
          "Elahe Yuruddo (يُرَدُّ إِلَيْهِ)",
          "Ha'a Meem (حم)",
          "Qala Fama Khatbukum (خَطْبُكُمْ فَمَا قَال)",
          "Qadd Sami Allah (اللَّهُ سَمِعَ قَدْ)",
          "Tabarakallazi (الَّذِي تَبَارَكَ)",
          "Amma Yatasa'aloon (يَتَسَاءَلُونَ عَمَّ)"
        ];

        // Assuming data is an array of juz, if not, adjust accordingly
        setJuzList(
          Array.from({ length: 30 }, (_, index) => ({
            number: index + 1,
            name: juzNames[index],
            surahsCount: data.data.surahs.filter(surah => surah.juz === index + 1).length
          }))
        );
      } catch (error) {
        console.error('Error fetching Juz list:', error);
      }
    };

    fetchJuzList();
  }, []);

  return (
    <Grid style={{ marginTop: '20px' }} container spacing={2}>
      {juzList.map((juz) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={juz.number}>
         <Link to={`/juz/${juz.number}`}  style={{  textDecoration: 'none' }}>
          <Card style={{ backgroundColor: 'darkslategray', marginLeft: '5px', marginRight: '5px', height: '180px' }}>
            <CardContent>
              <Typography variant="h5" sx={{ color: 'gold', fontFamily:'Cinzel Decorative' }} component="div">
                {juz.name}
              </Typography>
              <Typography variant="h6" sx={{ color: 'goldenrod' }} component="div">
               Juz/Parah no. {juz.number}
              </Typography>
              
                <Typography variant="body2"  style={{ color: 'gold', textDecoration: 'none' }} sx={{ marginTop: '10px' }}>
                 Click to View Details
                </Typography>
            </CardContent>
          </Card>
          </Link>
        </Grid>
      ))}
    </Grid>
  );
};

export default ByJuz;
